import React, { useEffect, useState } from 'react';
import './index.css';
import clsx from 'classnames';
import { Loading, Position } from 'components';
import Nav from './components/Nav';
import ProductList from './components/ProductList';
import { useAppContext } from 'context';
import { usePageTitle, useProductList } from '../../hooks';
import { useNewProduct } from 'hooks/useProductData';

// 顶部背景图
const bannerList = [
  {
    img: '/img/productBig.jpg',
    className: 'product-center-top-banner-big',
  },
  {
    img: '/img/productSmall.jpg',
    className: 'product-center-top-banner-small',
  },
];
const ProductCenter = () => {
  // 设置页面标题
  usePageTitle('产品中心');
  const [productTypeList, setProductTypeList] = useState([]);
  const [imageCacheKey, setImageCacheKey] = useState(0); // 图片缓存键，用于切换分类时清除缓存
  const {
    state: { type, productCurrentPage },
    dispatch,
  } = useAppContext();
  const isNewType = type === 'new';
  // 获取产品列表数据
  const { data, loading, error, refresh } = useProductList();
  // 获取新产品列表数据
  const {
    data: newData,
    loading: newLoading,
    error: newError,
    refresh: newRefresh,
  } = useNewProduct();

  useEffect(() => {
    if (!loading && !type) {
      dispatch({ type: 'SET_PRODUCT_TYPE', payload: data?.clist[0]?.cid });
    }
    if (data) {
      setProductTypeList([...data?.clist, { name: '最新产品', cid: 'new' }]);
    }
  }, [loading, data, dispatch, type]);

  // 监听 type 变化，当分类切换时清除图片缓存
  useEffect(() => {
    if (type) {
      setImageCacheKey((prev) => prev + 1);
    }
  }, [type]);

  const productName = isNewType
    ? '最新产品'
    : data?.clist?.find((v) => v.cid === type)?.name;

  // 错误状态
  if (error || newError) {
    return (
      <div
        className={clsx('news-top')}
        style={{ minHeight: window.innerHeight }}
      >
        <Position list={['首页', '产品中心']} />
        <div className='error-container'>
          <p>数据加载失败: {error}</p>
          <button
            onClick={() => {
              refresh();
              newRefresh();
            }}
          >
            重试
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={clsx('product-center-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部Banner */}
      {bannerList.map((v, index) => (
        <img
          key={index}
          src={v.img}
          alt=''
          width={'100%'}
          height={'100%'}
          className={clsx(v.className)}
        />
      ))}
      {/* 当前位置 */}
      <Position
        list={['首页', '产品中心', productName]}
        firstType={data?.clist[0]?.cid}
      />
      {/* 产品中心内容 */}
      {!loading || !newLoading ? (
        <div className={clsx('product-center-content')}>
          {/* 左侧导航栏 */}
          <Nav clist={productTypeList} />
          {/* 右侧内容 */}
          <ProductList
            currentPage={productCurrentPage}
            setCurrentPage={(page) => {
              dispatch({ type: 'SET_PRODUCT_CURRENT_PAGE', payload: page });
            }}
            dlist={isNewType ? newData : data?.dlist}
            imageCacheKey={imageCacheKey} // 传递缓存键给产品列表
          />
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default ProductCenter;
